import { render, staticRenderFns } from "./banner_layout.vue?vue&type=template&id=05037285&scoped=true&"
import script from "./banner_layout.vue?vue&type=script&lang=js&"
export * from "./banner_layout.vue?vue&type=script&lang=js&"
import style0 from "./banner_layout.vue?vue&type=style&index=0&id=05037285&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05037285",
  null
  
)

export default component.exports